<template lang="html">
  <standard-dialog title="Select Bus">
    <template #activator="{ on }">
      <slot name="activator" :on="on">
        <v-btn flat color="secondary" v-on="on">
          Select a bus
        </v-btn>
      </slot>
    </template>
    <template #main>
      <v-select
      label="Available Bus Types"
      :items="buses"
      :value="value"
      @input="$emit('input', $event)"/>
    </template>
    <template #actions="{ deactivate }">
      <v-btn
        flat
        color="warning"
        v-on="deactivate"
        @click="$emit('input', null)">
        Cancel
      </v-btn>
      <v-btn
        flat
        color="primary"
        v-on="deactivate"
        @click="$emit('continue')">
        Continue
      </v-btn>
    </template>
  </standard-dialog>
</template>

<script>
import StandardDialog from './StandardDialog';
export default {
  components: {
    'standard-dialog': StandardDialog,
  },
  props: {
    value: {
      default: null
    },
    buses: {
      type: Array,
      default: () => ([])
    }
  }
}
</script>

<style lang="css" scoped>
</style>
